import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { colors } from 'ui_system/compass';

const BackNav = styled('div')`
  width: 100%;
  background: ${colors.background.dark};
  color: #fff;
  text-align: center;
  height: 61px;
  line-height: 61px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 111111;
  font-size: 18px;
  font-weight: 400;
`;

const Arrow = styled('div')`
  color: #fff;
  position: absolute;
  left: 10px;
  top: 4px;
  font-size: 20px;
  cursor: pointer;
`;

const Title = styled('div')``;

export const MobileBackNav = ({ title, onClose }) => {
  return (
    <BackNav>
      <Arrow onClick={onClose} className="af-icon af-chevron-left" />
      <Title>{title}</Title>
    </BackNav>
  );
};

MobileBackNav.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
